import React from "react";
import FormationBuilderPage from "../FormationBuilderPage";

const IngenieurSureteNucleaire = () => {
  const ingenieurSureteNucleaireProgram = [
    {
      title: "Animation de réunion",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Rédaction de synthèse",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Prise de parole",
      img: "/assets/images/icon/tuyaux.svg",
    },
    {
      title: "Management de projet",
      img: "/assets/images/icon/work.svg",
    },
    {
      title: "Introduction au génie nucléaire",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Initiation à la sureté nucléaire et à l’analyse de sureté",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "Résistance des matériaux RDM",
      img: "/assets/images/icon/work-women.svg",
    },
    {
      title: "Normes RCCM 2",
      img: "/assets/images/icon/redaction.svg",
    },
    {
      title: "Schématique et implantation",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Génie civil et structures",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "Tuyauteries et réglementation",
      img: "/assets/images/icon/balance.svg",
    },
    {
      title: "Conduite de chantiers",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "Initiation aux études probabilistes de sûreté",
      img: "/assets/images/icon/network-card.svg",
    },
    {
      title: "Inititaion à la conduite Incidentelle et Accidentelle",
      img: "/assets/images/icon/component-card.svg",
    },
    {
      title: "Règle générale d'exploitation",
      img: "/assets/images/icon/component-card.svg",
    },
    {
      title: "Risque incendie en milieu nucléaire",
      img: "/assets/images/icon/balance.svg",
    },
    {
      title: "Conduite Incidentelle et Accidentelle",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "Approche par Etat avancée",
      img: "/assets/images/icon/network-card.svg",
    },
    {
      title: "Conduite Incidentelle et Accidentelle avancée",
      img: "/assets/images/icon/component-card.svg",
    },
    {
      title: "Projet de fin de cursus",
      img: "/assets/images/icon/light.svg",
    },
  ];

  return (
    <FormationBuilderPage
      category="Nucléaire"
      titleColor="#20FFA4"
      title="Ingénieur Sûreté Nucléaire"
      duration={11}
      description={
        <React.Fragment>
          <p>
            Grâce au partenariat entre Liora et SEGULA Technologies, rejoignez
            un groupe d’ingénierie mondiale à forte croissance en tant que
            Ingénieur Sûreté Nucléaire, après une formation accélérée de 11
            semaines.
          </p>
          <p>
            Impression 3D, réalité augmentée, véhicule autonome, usine du
            futur... rythment le quotidien de nos 13 000 ingénieux
            collaborateurs, pourquoi pas le vôtre ?
          </p>
        </React.Fragment>
      }
      image="/assets/images/home/nucleaire.png"
      program={ingenieurSureteNucleaireProgram}
      formId="bad1453f-05a6-46f5-92b3-35657ea37c92"
    />
  );
};

export default IngenieurSureteNucleaire;
